import * as React from "react";
import { callApi } from "../../utils/api";
import AddBillType from "./AddBillType";
import { ADMIN_ROLE } from "../../utils/role";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";

declare var $: any;

export interface BillType {
  id: number;
  name: string;
  status?: string | number;
}

interface AllProps {
  history: any;
}

class ManageBillType extends React.Component<AllProps> {
  state = {
    billTypes: [],
    selectedBillType: {
      id: 0,
      name: "",
    },
    billTypeToUpdate: {
      id: 0,
      status: 0,
    },
    isFileRefresh: false,
    isBackLoading: false,
  };

  componentDidMount() {
    this.listBillType();
  }

  listBillType = () => {
    this.setState({ isFileRefresh: false });
    callApi("GET", "bill_type_get_management.php")
      .then((res) => res.data)
      .then((response) => {
        const files = response.data || [];
        files.forEach((file: any, index: number) => {
          Object.keys(file).forEach((fileKey) => {
            file[fileKey] =
              file[fileKey] === null || file[fileKey] === undefined
                ? ""
                : typeof file[fileKey] !== "string"
                ? String(file[fileKey])
                : file[fileKey];
          });
          file.index = index + 1;
          file.status_label = String(file.status) === "1" ? "Active" : "Inactive";
        });
        this.setState({ billTypes: files, isFileRefresh: true });
      })
      .catch((err) => console.log(err));
  };

  handleBack = () => {
    if (this.state.isBackLoading) {
      return;
    }
    this.setState({ isBackLoading: true }, () => {
      requestAnimationFrame(() => this.props.history.goBack());
    });
  };

  addBillType = () => {
    this.setState({ selectedBillType: { id: 0, name: "" } });
  };

  editBillType = (billType: BillType) => {
    this.setState({ selectedBillType: billType });
  };

  confirmStatusUpdate = (billType: BillType, status: number) => {
    this.setState({
      billTypeToUpdate: {
        id: billType.id,
        status,
      },
    });
  };

  updateBillTypeStatus = () => {
    callApi("POST", "bill_type_status_update.php", this.state.billTypeToUpdate)
      .then((res) => res.data)
      .then((response) => {
        if (response.result === false) {
          ToastsStore.error(response.message || "Failed to update Bill Type status");
          return;
        }
        ToastsStore.success(response.message);
        this.listBillType();
      })
      .catch(() => ToastsStore.error("Something went wrong, please try again"));
  };

  render() {
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["role_id"] : "";

    const columns = [
      { header: "ID", key: "index" },
      { header: "Name", key: "name" },
      { header: "Status", key: "status_label" },
      {
        header: "Actions",
        td: (file: BillType & { status?: string }) => {
          const isActive = String(file.status) === "1";
          return (
            <div className="btn-group mb-2 mr-2">
              <button type="button" className="btn btn-primary">
                Action
              </button>
              <button
                type="button"
                className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="sr-only">Toggle Dropdown</span>
              </button>
              <div className="dropdown-menu">
                <a
                  className="dropdown-item"
                  data-toggle="modal"
                  data-target="#bill-type-form"
                  onClick={() => this.editBillType(file)}
                >
                  Edit
                </a>
                {role_id === ADMIN_ROLE && (
                  <a
                    className="dropdown-item"
                    data-toggle="modal"
                    data-target={isActive ? "#deactivate-bill-type" : "#activate-bill-type"}
                    onClick={() => this.confirmStatusUpdate(file, isActive ? 0 : 1)}
                  >
                    {isActive ? "Deactivate" : "Activate"}
                  </a>
                )}
              </div>
            </div>
          );
        },
      },
    ];

    return (
      <section className="pcoded-main-container">
        <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-header">
                          <h5>Bill Type Management</h5>
                          <button
                            className="btn btn-primary"
                            style={{ float: "right" }}
                            disabled={this.state.isBackLoading}
                            onClick={this.handleBack}
                          >
                            {this.state.isBackLoading ? (
                              <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                            ) : (
                              "Back"
                            )}
                          </button>
                        </div>
                        <div className="card-body">
                          <div className="dt-responsive table-responsive">
                            <a
                              className="btn btn-primary m-b-20"
                              data-toggle="modal"
                              data-target="#bill-type-form"
                              onClick={this.addBillType}
                            >
                              + Add Bill Type
                            </a>
                            {this.state.isFileRefresh && (
                              <ReactFlexyTable
                                data={this.state.billTypes}
                                columns={columns}
                                sortable
                                globalSearch
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddBillType selectedBillType={this.state.selectedBillType} listBillType={this.listBillType} />
        <div className="modal fade" id="deactivate-bill-type" role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Deactivate Bill Type</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <h6>Are you sure you want to deactivate this Bill Type?</h6>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={this.updateBillTypeStatus}
                >
                  Deactivate
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="activate-bill-type" role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Activate Bill Type</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <h6>Are you sure you want to activate this Bill Type?</h6>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={this.updateBillTypeStatus}
                >
                  Activate
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ManageBillType;
